import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { ColoredSkeleton } from '../DynamicAsset/components/AssetsLoading';

export interface DynamicAssetLoadingProps {
  productsAvailable?: number;
}

export const DynamicAssetLoading: React.FC<DynamicAssetLoadingProps> = ({
  productsAvailable = 5,
}) => {
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <VStack space="stack.xxxs" w="full">
      <HStack space="inline.nano">
        {Array.from({ length: productsAvailable }).map((_, index) => (
          <ColoredSkeleton
            key={index}
            width="80px"
            height={Typography['fontsize.display']}
            borderRadius={BoxRadius.lg}
          />
        ))}
      </HStack>
      <HStack space="inline.xxxs">
        <ColoredSkeleton
          width={isMobile ? 'full' : '2/5'}
          height={Typography['fontsize.display']}
          borderRadius={BoxRadius.lg}
        />
        {!isMobile && (
          <ColoredSkeleton
            width="10%"
            height={Typography['fontsize.display']}
            borderRadius={BoxRadius.lg}
          />
        )}
      </HStack>
      {!isMobile && (
        <HStack justifyContent="space-between">
          <ColoredSkeleton
            width="3/5"
            height={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
          />
          <ColoredSkeleton
            width="1/5"
            height={Typography['fontsize.md']}
            borderRadius={BoxRadius.sm}
          />
        </HStack>
      )}
      <ColoredSkeleton
        width="full"
        height={Typography['fontsize.xxl']}
        borderRadius={BoxRadius.sm}
      />
      <UI.Shadow level={2} borderTopRadius={BoxRadius.sm}>
        <VStack space="stack.nano">
          {Array.from({ length: 3 }).map((_, index) => (
            <ColoredSkeleton
              key={index}
              width="full"
              height={isMobile ? '180px' : '80px'}
              borderRadius={BoxRadius.xs}
            />
          ))}
        </VStack>
      </UI.Shadow>
    </VStack>
  );
};
